import {
    Grid,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const MainGrid = styled(Grid)(({ theme }) => ({
    marginTop: 64, marginLeft: 240, padding: 30
}));
